import { MinusIcon, PlusIcon } from "./review-icons";

/**
 * A count with − and +, as the review row, the review screen and the card page
 * all set one. A port of the iOS `AdminCountStepper`.
 */
export function CountStepper({
  count,
  onChange,
  minimum = 0,
  zeroLabel,
  disabled = false,
  tall = false,
}: {
  count: number;
  onChange: (count: number) => void;
  /** The count cannot go below it: copies held for open quotes. */
  minimum?: number;
  /** Shown instead of 0, when zero means something other than none. */
  zeroLabel?: string;
  disabled?: boolean;
  /** The height of the price field beside it, rather than a row's. */
  tall?: boolean;
}) {
  const height = tall ? "h-[46px]" : "h-10";
  return (
    <div className={`flex ${height} shrink-0 items-center rounded-full bg-surface-strong text-white`}>
      {/* Held at the floor, not disabled, so the focus stays on it as the count comes down to it. */}
      <button
        type="button"
        className={`flex ${height} w-9 items-center justify-center disabled:opacity-40 aria-disabled:opacity-40`}
        onClick={count > minimum ? () => onChange(count - 1) : undefined}
        disabled={disabled}
        aria-disabled={count <= minimum || undefined}
        aria-label={count === 1 && zeroLabel !== undefined ? "Don't track stock" : "One copy fewer"}
      >
        <MinusIcon />
      </button>
      <span className="min-w-[22px] text-center" aria-live="polite">
        {count === 0 && zeroLabel !== undefined ? (
          <span className="text-[13px] font-semibold text-muted">{zeroLabel}</span>
        ) : (
          <span className="text-[15px] font-semibold tabular-nums">{count}</span>
        )}
      </span>
      <button
        type="button"
        className={`flex ${height} w-9 items-center justify-center disabled:opacity-40`}
        onClick={() => onChange(count + 1)}
        disabled={disabled}
        aria-label="One copy more"
      >
        <PlusIcon />
      </button>
    </div>
  );
}
